import { FC, useEffect, useRef, useState } from 'react'
import { SelectDropdown } from '@components-v2/molecules/SelectDropdown'
import { SelectMenuTrigger } from '@components-v2/atoms/SelectMenuTrigger'
import styles from './index.module.scss'

type Item = {
  instance: {
    id: string
    name: string
  }

  isSelected: boolean
}

type Props = {
  placeholder?: string
  onSelect: (id: string) => void
  onUnselect: (id: string) => void
  onUnselectAll: () => void
  selectedItems: { id: string; name: string }[]
  selectableItems: Item[]
  isMultiple?: boolean
}

export const CustomSelectFieldGroup: FC<Props> = ({
  placeholder = '',
  onSelect,
  onUnselect,
  onUnselectAll,
  selectedItems,
  selectableItems,
  isMultiple = true,
}) => {
  const ref = useRef<HTMLDivElement>()

  const [isOpen, setIsOpen] = useState(false)

  const close = () => setIsOpen(false)
  const open = () => setIsOpen(true)

  const handleClickOutside = (event: MouseEvent) => {
    if (!ref.current) {
      return
    }

    if (ref.current.contains(event.target as Node)) {
      return
    }

    close()
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div className={styles.container} ref={ref}>
      <SelectMenuTrigger
        placeholder={placeholder}
        onClick={(e) => {
          e.preventDefault()
          open()
        }}
        onKeyPress={(e) => {
          e.preventDefault()
          open()
        }}
        selectedItems={selectedItems}
        onDeleteSelectedItem={onUnselect}
        onDeletedAllSelectedItems={onUnselectAll}
        isMultiple={isMultiple}
      />
      {isOpen && (
        <div className={styles.dropdown}>
          <SelectDropdown items={selectableItems} onSelect={onSelect} onUnselect={onUnselect} />
        </div>
      )}
    </div>
  )
}
